/* eslint-disable no-template-curly-in-string */

import { searchProductInRetailer_BackEnd } from "pricePinger-shared/dist/product_search";
import { serviceGetBackendAPIParams } from "src/api/service/services";

export async function parseBackend(retailer: any, productTitle: string) {
  try {
    const APIParams = serviceGetBackendAPIParams();
    const response = await searchProductInRetailer_BackEnd(
      retailer,
      productTitle,
      APIParams
    );
    return response;
  } catch (error) {
    console.error("Error parsing retailer:", error);
  }
}
